module.exports = __webpack_public_path__ + "media/assets/img/slider/01-68c25447bcf4497d03268dab4c36eba9.jpg";